import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00ee3124")

_pushScopeId("data-v-00ee3124")
const _hoisted_1 = { class: "grid h-full grid-cols-4" }
const _hoisted_2 = { class: "flex flex-col col-span-3" }
const _hoisted_3 = { class: "flex items-center justify-center border-b bg-primary-dark" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pr-2" }, "Phase:", -1)
const _hoisted_5 = {
  key: 0,
  class: "h-full col-span-1 border-l bg-primary-dark"
}
const _hoisted_6 = { class: "grid h-full grid-rows-6 shadow-md bg-background" }
const _hoisted_7 = { class: "row-span-5" }
const _hoisted_8 = {
  key: 0,
  class: "p-4 mb-4 text-sm text-center text-gray-300 rounded bg-background"
}
const _hoisted_9 = { class: "bg-primary-dark" }
const _hoisted_10 = {
  key: 0,
  class: "p-4 text-lg"
}
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = {
  key: 1,
  class: "p-4 text-lg"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Select an Event ")
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "text-sm" }, " Double click on a cell to add additional information ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_event_reason_selector = _resolveComponent("event-reason-selector")
  const _component_maneuver_reason_selector_search = _resolveComponent("maneuver-reason-selector-search")
  const _component_recommendation_email_modal = _resolveComponent("recommendation-email-modal")
  const _component_confirm_modal_component = _resolveComponent("confirm-modal-component")
  const _component_toast_component = _resolveComponent("toast-component")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentPhase = $event)),
          class: "p-2 my-4 border rounded focus:outline-none",
          "data-testid": "phase-select"
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.phaseItems, (phase, phaseIndex) => {
            return (_openBlock(), _createBlock("option", {
              key: phaseIndex,
              value: phase
            }, _toDisplayString(_ctx.formatPhase(phase.phase)), 9, ["value"]))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.currentPhase]
        ])
      ]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentPhase.component), {
        academicEvents: _ctx.academicEvents,
        studentEvents: _ctx.computedEvents,
        unlockedEvents: _ctx.computedUnlockedEvents,
        maneuvers: _ctx.maneuvers,
        readonly: _ctx.readonly,
        onGridEventSelected: _ctx.handleEventSelected,
        onGridCellSelected: _ctx.handleGridCellClick,
        onCreateEvent: _ctx.handleCreateEvent,
        onDeleteEvent: _ctx.handleDeleteEvent,
        onGradeEvent: _ctx.handleGradeEvent,
        onGradeEvents: _ctx.handleGradeEvents,
        onGridEventNameClick: _ctx.handleEventNameClick
      }, null, 8, ["academicEvents", "studentEvents", "unlockedEvents", "maneuvers", "readonly", "onGridEventSelected", "onGridCellSelected", "onCreateEvent", "onDeleteEvent", "onGradeEvent", "onGradeEvents", "onGridEventNameClick"]))
    ]),
    (!_ctx.readonly)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              (!_ctx.selectedEvent && !_ctx.selectedGridCell)
                ? (_openBlock(), _createBlock("div", _hoisted_8, " Double click on a cell to add additional information "))
                : _createCommentVNode("", true),
              (_ctx.selectedEvent)
                ? (_openBlock(), _createBlock(_component_event_reason_selector, {
                    key: 1,
                    class: "mb-4",
                    event: _ctx.selectedEvent,
                    onGradeEvent: _ctx.handleGradeEvent,
                    onCancel: _ctx.clearSelectedEvent,
                    onError: _ctx.handleError
                  }, null, 8, ["event", "onGradeEvent", "onCancel", "onError"]))
                : _createCommentVNode("", true),
              (!_ctx.hideSearch && _ctx.selectedGridCell && _ctx.selectedGridCell.event)
                ? (_openBlock(), _createBlock(_component_maneuver_reason_selector_search, {
                    key: 2,
                    event: _ctx.selectedGridCell.event,
                    maneuver: _ctx.selectedGridCell.maneuver,
                    maneuverViewModel: _ctx.selectedGridCell.maneuver,
                    optionalFiltersReasonKeys: _ctx.optionalFiltersReasonKeys,
                    optionalFiltersManeuverKeys: _ctx.optionalFiltersManeuverKeys,
                    reasons: _ctx.reasons,
                    corrections: _ctx.corrections,
                    comments: _ctx.comments,
                    onCancel: _ctx.clearSelectedGridCell,
                    onAddReason: _ctx.addReason,
                    onRemoveReason: _ctx.removeReason,
                    onAddCorrection: _ctx.addCorrection,
                    onRemoveCorrection: _ctx.removeCorrection,
                    onUpdateComments: _ctx.updateComments,
                    onError: _ctx.handleError,
                    class: ""
                  }, null, 8, ["event", "maneuver", "maneuverViewModel", "optionalFiltersReasonKeys", "optionalFiltersManeuverKeys", "reasons", "corrections", "comments", "onCancel", "onAddReason", "onRemoveReason", "onAddCorrection", "onRemoveCorrection", "onUpdateComments", "onError"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_9, [
              (_ctx.getLastSelectedEventDetails())
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createTextVNode(" Event - " + _toDisplayString(_ctx.getLastSelectedEventDetails().name) + " ", 1),
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.getLastSelectedEventDetails().subject), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14
                  ])),
              _createVNode("div", null, [
                (_ctx.getLastEventManeuverCount() === 0)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleEmailRecommendationEvent && _ctx.handleEmailRecommendationEvent(...args))),
                      disabled: _ctx.getLastEventManeuverCount() === 0,
                      class: "z-50 float-right p-2 mr-4 text-black rounded bg-background"
                    }, " Email recommendations (" + _toDisplayString(_ctx.getLastEventManeuverCount()) + ") ", 9, ["disabled"]))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleEmailRecommendationEvent && _ctx.handleEmailRecommendationEvent(...args))),
                      class: "float-right p-2 mr-4 text-black rounded bg-highlight"
                    }, " Email recommendations (" + _toDisplayString(_ctx.getLastEventManeuverCount()) + ") ", 1))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_recommendation_email_modal, { ref: "recommendationModal" }, null, 512),
    _createVNode(_component_confirm_modal_component, { ref: "confirmDeleteEventModal" }, null, 512),
    _createVNode(_component_toast_component, { ref: "toastComponent" }, null, 512)
  ]))
})